import {
  AddLocationsToRetailerNetworkLocationGroupPolicy,
  AddLocationsToRetailerNetworkPolicy,
  CreateRetailerNetworkLocationGroupsPolicy,
  CreateRetailerNetworkPolicy,
  CreateRetailerNetworkUserPolicy,
  DeleteRetailerNetworkPolicy,
  ReadRetailerNetworkLocationGroupPolicy,
  ReadRetailerNetworkLocationGroupsAndPerformanceGoalPolicy,
  ReadRetailerNetworkLocationGroupsPolicy,
  ReadRetailerNetworkLocationPolicy,
  ReadRetailerNetworkLocationsAndPerformanceGoalPolicy,
  ReadRetailerNetworkLocationsPolicy,
  ReadRetailerNetworkPerformanceGoalPolicy,
  ReadRetailerNetworkPolicy,
  ReadRetailerNetworksPolicy,
  ReadRetailerNetworkUsersPolicy,
  RemoveLocationFromRetailerNetworkPolicy,
  RemoveLocationGroupFromRetailerNetworkPolicy,
  RemoveLocationsFromRetailerNetworkPolicy,
  RemoveLocationsToRetailerNetworkLocationGroupPolicy,
  RemoveRetailerNetworkLocationGroupsPolicy,
  RemoveUserFromRetailerNetworkPolicy,
  UpdateRetailerNetworkLocationGroupsPolicy,
  UpdateRetailerNetworkLocationsPolicy,
  UpdateRetailerNetworkPolicy,
  UpdateRetailerNetworkUserPolicy,
} from '@open-commerce/oc-authorization-policies';

import { UserAction } from './user-actions.types';

export const AddLocationsToRetailerNetworkLocationGroup: UserAction = (params) => ({
  policy: AddLocationsToRetailerNetworkLocationGroupPolicy('uuid'),
  params,
});

export const AddLocationsToRetailerNetwork: UserAction = (params) => ({
  policy: AddLocationsToRetailerNetworkPolicy('uuid'),
  params,
});

export const CreateRetailerNetworkLocationGroups: UserAction = (params) => ({
  policy: CreateRetailerNetworkLocationGroupsPolicy('uuid'),
  params,
});

export const DeleteRetailerNetwork: UserAction = (params) => ({
  policy: DeleteRetailerNetworkPolicy('uuid'),
  params,
});

export const ReadRetailerNetworkLocationGroupsAndPerformanceGoal: UserAction = (params) => ({
  policy: ReadRetailerNetworkLocationGroupsAndPerformanceGoalPolicy('uuid'),
  params,
});

export const ReadRetailerNetworkLocationGroups: UserAction = (params) => ({
  policy: ReadRetailerNetworkLocationGroupsPolicy('uuid'),
  params,
});

export const ReadRetailerNetworkLocationsAndPerformanceGoal: UserAction = (params) => ({
  policy: ReadRetailerNetworkLocationsAndPerformanceGoalPolicy('uuid'),
  params,
});

export const ReadRetailerNetworkLocations: UserAction = (params) => ({
  policy: ReadRetailerNetworkLocationsPolicy('uuid'),
  params,
});

export const ReadRetailerNetworkPerformanceGoal: UserAction = (params) => ({
  policy: ReadRetailerNetworkPerformanceGoalPolicy('uuid'),
  params,
});

export const ReadRetailerNetworkUsers: UserAction = (params) => ({
  policy: ReadRetailerNetworkUsersPolicy('uuid'),
  params,
});

export const ReadRetailerNetwork: UserAction = (params) => ({
  policy: ReadRetailerNetworkPolicy('uuid'),
  params,
});

export const RemoveLocationFromRetailerNetwork: UserAction = (params) => ({
  policy: RemoveLocationFromRetailerNetworkPolicy('uuid'),
  params,
});

export const RemoveLocationGroupFromRetailerNetwork: UserAction = (params) => ({
  policy: RemoveLocationGroupFromRetailerNetworkPolicy('uuid'),
  params,
});

export const RemoveLocationsFromRetailerNetworkLocationGroup: UserAction = (params) => ({
  policy: RemoveLocationsToRetailerNetworkLocationGroupPolicy('uuid'),
  params,
});

export const RemoveLocationsFromRetailerNetwork: UserAction = (params) => ({
  policy: RemoveLocationsFromRetailerNetworkPolicy('uuid'),
  params,
});

export const RemoveRetailerNetworkLocationGroups: UserAction = (params) => ({
  policy: RemoveRetailerNetworkLocationGroupsPolicy('uuid'),
  params,
});

export const RemoveUserFromRetailerNetwork: UserAction = (params) => ({
  policy: RemoveUserFromRetailerNetworkPolicy('uuid'),
  params,
});

export const UpdateRetailerNetworkLocationGroups: UserAction = (params) => ({
  policy: UpdateRetailerNetworkLocationGroupsPolicy('uuid'),
  params,
});

export const UpdateRetailerNetworkLocations: UserAction = (params) => ({
  policy: UpdateRetailerNetworkLocationsPolicy('uuid'),
  params,
});

export const UpdateRetailerNetworkUser: UserAction = (params) => ({
  policy: UpdateRetailerNetworkUserPolicy('uuid'),
  params,
});

export const UpdateRetailerNetwork: UserAction = (params) => ({
  policy: UpdateRetailerNetworkPolicy('uuid'),
  params,
});

export const ReadRetailerNetworks: UserAction = () => ({
  policy: ReadRetailerNetworksPolicy(),
});

export const ReadRetailerNetworkLocation: UserAction = (params) => ({
  policy: ReadRetailerNetworkLocationPolicy('uuid'),
  params,
});

export const ReadRetailerNetworkLocationGroup: UserAction = (params) => ({
  policy: ReadRetailerNetworkLocationGroupPolicy('uuid'),
  params,
});

export const CreateRetailerNetwork: UserAction = () => ({
  policy: CreateRetailerNetworkPolicy(),
});

export const CreateRetailerNetworkUser: UserAction = () => ({
  policy: CreateRetailerNetworkUserPolicy(),
});
